function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgRx = function SvgRx(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 30,
    fill: "none",
    viewBox: "0 0 10 13"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M0 1.445C0 1.062.15.695.419.423A1.42 1.42 0 0 1 1.429 0h3.218a3.2 3.2 0 0 1 2.275.953 3.27 3.27 0 0 1 .942 2.3 3.27 3.27 0 0 1-.942 2.299 3.2 3.2 0 0 1-2.275.952h-.062L7.15 9.096 8.79 7.44a.71.71 0 0 1 1.002.009.727.727 0 0 1 .008 1.013L8.16 10.118l1.64 1.657a.727.727 0 0 1-.01 1.013.71.71 0 0 1-1.002.01L7.15 11.14l-1.64 1.657a.71.71 0 0 1-1.001-.009.727.727 0 0 1-.01-1.013l1.64-1.657-3.574-3.614H1.43v3.614a.73.73 0 0 1-.21.511.71.71 0 0 1-1.01 0 .73.73 0 0 1-.21-.511zM1.43 5.06h3.217c.474 0 .929-.19 1.264-.53a1.817 1.817 0 0 0 0-2.554 1.78 1.78 0 0 0-1.264-.53H1.43z",
    clipRule: "evenodd"
  }));
};
export default SvgRx;